<template>
  <li class="recent-content-item">
    <router-link 
      :to="{ name: 'ForumThread', params: { nid: topic.nid } }" 
      class="topic-link typo-body-2"
    >
      {{ topic.title }}
      <div class="topic-meta">
        <span class="author">{{ topic.name }}</span>
        <span class="separator">•</span>
        <span class="comments-count">{{ topic.comment_count }} comentarios</span>
      </div>
    </router-link>
  </li>
</template>

<script>
export default {
  name: 'RecentContentTopic',
  props: {
    topic: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.recent-content-item {
  margin-bottom: 12px;
  list-style-type: none;
}

.topic-link {
  color: var(--color-text-primary);
  text-decoration: none;
  display: block;
  padding: 8px 0;
  transition: color 0.3s ease;
}

.topic-link:hover {
  color: var(--color-highlight);
}

.topic-meta {
  display: flex;
  align-items: center;
  font-size: 0.85em;
  color: var(--color-text-secondary);
  margin-top: 4px;
}

.separator {
  margin: 0 6px;
}

.author {
  font-style: italic;
}

.comments-count {
  white-space: nowrap;
}
</style> 